import React from 'react'
import NotificationsListItemLoader from '../NotificationsListItemLoader'

const NotificationsListLoader = () => (
  <div className="loader">
    <NotificationsListItemLoader />
    <NotificationsListItemLoader />
    <NotificationsListItemLoader />
  </div>
)

NotificationsListLoader.displayName = 'NotificationsListLoader'

export default NotificationsListLoader
